import { Controller } from '@hotwired/stimulus';
import CurrentPage from '@frontend/app/features/CurrentPage';
import CurrentUser from '@frontend/app/features/CurrentUser';
import { loadAndDisplay as loadAndDisplayInModal } from '@controllers/main/modal-window_controller';
import { show, displayNone, displayReset } from '@frontend/utils/dom';
import { extract as extractQueryParams } from '@frontend/utils/query-params';

export default class extends Controller {
  static values = {
    articleId: Number,
    shareModalUrl: String,
    hasPaywall: Boolean,
  };

  static targets = [
    'markdownContent',
    'shareUrlPromotionSubscriber',
    'shareUrlPromotionTopbar',
    'shareUrlPromotionTopbarMessageNoAuthor',
    'shareUrlPromotionTopbarMessageWithAuthor',
    'shareUrlPromotionTopbarMessageAuthor',
    'tabButton',
    'readingTabButton',
    'listeningTabButton',
    'visibleWhenReading',
    'visibleWhenListening',
    'speakerIcon',
  ];

  connect() {
    if (this.tabButtonTargets.length == 2) {
      this.updateSpeakerIcon(false);

      if (CurrentPage.hasHash('hoeren')) {
        this.setListeningTabActive();
      } else {
        this.setReadingTabActive();
      }
    }

    document.addEventListener(
      'article:display-share-url-promotion-topbar',
      this.showShareUrlPromotionTopbar.bind(this)
    );
    document.addEventListener(
      'audio-player:playing',
      this.handleAudioPlaying.bind(this)
    );
    document.addEventListener(
      'audio-player:stopped',
      this.handleAudioStopped.bind(this)
    );

    this.displayShareUrlPromotionTopbarForPocketUsers();
    this.displayShareUrlPromotionForSubscribers();
  }

  openReadingTab() {
    CurrentPage.setHash('lesen');
    this.setReadingTabActive();
  }

  setReadingTabActive() {
    this.setTabActive(this.readingTabButtonTarget);
    this.visibleWhenListeningTargets.forEach((element) => displayNone(element));
    this.visibleWhenReadingTargets.forEach((element) => displayReset(element));
  }

  openListeningTab() {
    CurrentPage.setHash('hoeren');
    this.setListeningTabActive();
  }

  setListeningTabActive() {
    this.setTabActive(this.listeningTabButtonTarget);
    this.visibleWhenReadingTargets.forEach((element) => displayNone(element));
    this.visibleWhenListeningTargets.forEach((element) =>
      displayReset(element)
    );
  }

  setTabActive(activeTabElement) {
    this.tabButtonTargets.forEach((element) =>
      element.classList.remove('is-active')
    );
    activeTabElement.classList.add('is-active');
  }

  showShareUrlPromotionTopbar() {
    show(this.shareUrlPromotionTopbarTarget);

    const shareUrl = CurrentPage.getShareUrl();
    if (shareUrl.sharedBy) {
      this.shareUrlPromotionTopbarMessageAuthorTarget.innerHTML =
        shareUrl.sharedBy;
      show(this.shareUrlPromotionTopbarMessageWithAuthorTarget);
    } else {
      show(this.shareUrlPromotionTopbarMessageNoAuthorTarget);
    }
  }

  showShareUrlModal() {
    loadAndDisplayInModal(this.shareModalUrlValue);
  }

  handleAudioPlaying() {
    this.updateSpeakerIcon(true);
  }

  handleAudioStopped() {
    this.updateSpeakerIcon(false);
  }

  displayShareUrlPromotionTopbarForPocketUsers() {
    const params = extractQueryParams(window.location.search);
    if (params['utm_source'] === 'pocket-unlocked') {
      this.shareUrlPromotionTopbarMessageNoAuthorTarget.innerHTML =
        'Krautreporter schenkt dir diesen Artikel. Lerne unsere Arbeit jetzt kostenlos kennen.';
      show(this.shareUrlPromotionTopbarTarget);
      show(this.shareUrlPromotionTopbarMessageNoAuthorTarget);
      this.shareUrlPromotionTopbarTarget.classList.add(
        'article-share-url-promotion-topbar--pocket'
      );
    }
  }

  displayShareUrlPromotionForSubscribers() {
    if (!this.hasPaywallValue || !CurrentUser.isSubscriber()) return false;

    show(this.shareUrlPromotionSubscriberTarget);
  }

  updateSpeakerIcon(shouldBeOn) {
    if (shouldBeOn) {
      displayReset(this.speakerIconTarget);
    } else {
      displayNone(this.speakerIconTarget);
    }
  }
}

export function displayShareUrlPromotionTopbar() {
  document.dispatchEvent(
    new CustomEvent('article:display-share-url-promotion-topbar')
  );
}
